// @flow
import idx from 'idx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Container } from 'flux/utils';
import { graphql, compose } from 'react-apollo';

import {
  FIRST_PAGE_VAR,
  ChatStream,
  lastStreamItemSequenceNumber,
} from 'chat/components/ChatStream';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import ChatActions from 'chat/actions/ChatActions';
import ChatWelcomeMessage from 'chat/components/ChatWelcomeMessage.jsx';
import UnreadStore from 'stores/UnreadStore';
import GET_CHAT_STREAM_ITEMS_QUERY from 'chat/components/ChatStream/queries/GetChatStreamItems.gql';

import './styles/OrganizationAnnouncementsPage.scss';

type Props = {
  organization: *,
  streamUuid: *,
  data: ReactApolloData<GetChatStreamItemsQuery>,
};

type State = {
  unreadCount: number,
};

class OrganizationAnnouncementsPage extends React.Component<Props, State> {
  static getStores() {
    return [UnreadStore];
  }

  static calculateState(prevState: ?State, props: Props) {
    return {
      unreadCount: UnreadStore.getUnreadCount(props.organization.uuid),
    };
  }

  static childContextTypes = {
    entityType: PropTypes.string,
  };

  getChildContext() {
    return { entityType: 'district' };
  }

  updateUnread = () => {
    if (this.state.unreadCount <= 0) {
      return;
    }
    const stream = idx(this.props, _ => _.data.chatStreams[0]);
    if (stream) {
      const seq = lastStreamItemSequenceNumber(stream.uuid);
      if (seq) {
        ChatActions.markReadUpto(stream.uuid, parseInt(seq, 10));
        UnreadStore.decrementUnreads(this.props.organization.uuid, this.state.unreadCount);
      }
    }
  };

  renderOrganizationStream(stream: *) {
    return (
      <div className="OrganizationAnnouncementsPage">
        <div className=" OrganizationAnnouncementsPage-stream">
          <ChatStream uuid={stream.uuid} onScrollToBottom={this.updateUnread} />
        </div>
      </div>
    );
  }

  renderOrganizationStreamPlaceholder(organization: *) {
    const headers = [
      `This is the beginning of your message history with ${organization.name}`,
      `No message were sent yet, come back later!`,
    ];

    return (
      <div className="OrganizationAnnouncementsPage">
        <ChatWelcomeMessage firstHeader={headers[0]} secondHeader={headers[1]} />
      </div>
    );
  }

  render() {
    const { organization, data } = this.props;

    if (!organization) {
      console.error('DWM - tried to render OrganizationAnnouncementsPage without an organization');
      return null;
    }

    if (data && data.loading) {
      return <CenteredLoadingIndicator />;
    }

    const stream = idx(data, _ => _.chatStreams[0]);

    return stream
      ? this.renderOrganizationStream(stream)
      : this.renderOrganizationStreamPlaceholder(organization);
  }
}

const withStream = graphql(GET_CHAT_STREAM_ITEMS_QUERY, {
  skip: ({ streamUuid }) => !streamUuid,
  options: ({ streamUuid }) => ({
    notifyOnNetworkStatusChange: true,
    variables: {
      uuid: streamUuid,
      ...FIRST_PAGE_VAR,
    },
  }),
});

export { OrganizationAnnouncementsPage };
export default compose(withStream)(
  Container.create(OrganizationAnnouncementsPage, {
    withProps: true,
    pure: false,
  })
);
